export { NFTCollection } from '@f8n/f8n-contracts/dist/abis/NFTCollection.generated';
